import { OverlayRef } from '@angular/cdk/overlay';
import { BehaviorSubject, Subject } from 'rxjs';

export class internalCdkOverlayRef {

    _availableHosts = new BehaviorSubject([]);
    $availableHosts = this._availableHosts.asObservable();
    // _availableTags = new BehaviorSubject([]);
    // $availableTags = this._availableTags.asObservable();
    _selectedPlatform = new BehaviorSubject(null);
    $selectedPlatform = this._selectedPlatform.asObservable();
    public isOpened = true;

    _time = new Subject;
    time$ = this._time.asObservable();

    constructor(private overlayRef: OverlayRef) {
    }
    close(): void {
        this.overlayRef.dispose();
        this.isOpened = false;
    }
    selectedHost(value): void {
    }
    valueChange(value) {
    }
}